<!--
 * @Description:
 * @Author: my2zzh <leo@easestrategy.com>
 * @Date: 2019-05-21 19:53:25
 * @LastEditTime: 2021-12-17 16:40:56
 * @LastEditors: 孙良松 <sunlas@easestrategy.com>
 -->
<template>
  <div class="home">
    <!--1.头部-->
    <header-frame @show-nav="(flag) => (hidden = flag)" />

    <div v-show="!hidden">
      <!--2.轮播图-->
      <carousel-frame />

      <!-- 3.公司要闻 -->
      <news-dynamic />

      <!-- 4.国网资讯、媒体聚焦、基层动态... -->
      <topic-news />

      <!-- 5.关于我们 -->
      <about-us />

      <!-- 6.党的建设 -->
      <party-building />

      <!-- 7.业务领域 -->
      <biz-field />

      <!-- 8.视觉交控 -->
      <visual />

      <!--9.公司媒体-->
      <company-media />

      <!--10.footer-->
      <footer-frame />
    </div>
  </div>
</template>

<script>
import HeaderFrame from '@/components/Header';
import CarouselFrame from './Carousel';
import NewsDynamic from '@/pages/home/NewsDynamic';
import TopicNews from '@/pages/home/TopicNews';
import AboutUs from './AboutUs.vue';
import PartyBuilding from './PartyBuilding.vue';
import BizField from './BizField.vue';
import Visual from './Visual.vue';
import CompanyMedia from '@/pages/home/CompanyMedia';
import FooterFrame from '@/components/Footer';
import $ from 'jquery';

export default {
  name: 'HomeIndex',
  components: {
    HeaderFrame,
    CarouselFrame,
    NewsDynamic,
    TopicNews,
    AboutUs,
    PartyBuilding,
    BizField,
    Visual,
    CompanyMedia,
    FooterFrame,
  },
  data() {
    return {
      isTop: false,
      isLeft: true,
      floatX: 0,
      floatY: 0,
      interval: 18.7,
      timer: null,
      hidden: false,
    };
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(this.timer);
    next();
  },

  methods: {
    floatDiv() {
      let docWidth = $(document).width();
      let docHeight = $('body').height();

      let floatWidth = $('#ad').width();
      let floatHeight = $('#ad').height();

      let offsetWidth = docWidth - floatWidth;
      let offsetHeight = docHeight - floatHeight;

      if (!this.isTop) {
        this.floatY++;
        if (this.floatY >= offsetHeight) {
          this.isTop = true;
        }
      } else {
        this.floatY--;
        if (this.floatY <= 0) {
          this.isTop = false;
        }
      }

      if (this.isLeft) {
        this.floatX++;
        if (this.floatX >= offsetWidth) {
          this.isLeft = false;
        }
      } else {
        this.floatX--;
        if (this.floatX <= 0) {
          this.isLeft = true;
        }
      }

      $('#ad').css({
        top: this.floatY,
        left: this.floatX,
      });
    },
    openAD() {
      window.open(
        'https://www.jchc.cn/m/#/content?first=7&second=37&third=375&type=15&isDown=false&title=%E4%B8%BB%E9%A2%98%E4%B8%93%E6%A0%8F'
      );
    },
    close() {
      clearInterval(this.timer);
      $('#ad').remove();
    },
  },
};
</script>

<style scoped lang="scss">
.ad {
  position: absolute;
  top: 0;
  left: 0;
  width: 267px;
  height: 148px;
  // background-color: transparent;
  // background-color: red;
  z-index: 999;

  div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // padding: 0 20px;
    width: 100%;
    height: 100%;
    font-size: 17px;
    color: #fff;

    p {
      margin-bottom: 10px !important;
    }
  }

  :hover {
    cursor: pointer;
  }

  img {
    width: 267px;
    height: 148px;
  }
}

.cross {
  position: absolute;
  right: 0;
  font-size: 24px;
  color: #fff;
}

// .icon {
//   position: absolute;
//   right: 0;
//   color: #fff;
// }

// .content {
//   background: url("../../../static/image/ad.png");
//   background-position: center;
//   background-size: cover;
// }
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue